import { createApp } from "vue";
import "@forevolve/bootstrap-dark/dist/css/bootstrap-dark.min.css";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";

createApp(App)
  .use(router)
  .mount("#app");
